import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillExpiredStyled } from './TrlPillExpired.styles';

export const TrlPillExpired = () => {
  return (
    <TrlPillContainer>
      <TrlPillExpiredStyled />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-EXPIRED" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
